module.exports = __webpack_public_path__ + "static/work-together-brown-69c1e434b875b8dc1dbc70bc0cff2903.svg";